/**
 * Carries no 'use client' directive on purpose.
 *
 * The pre-paint script interpolates the choice key into its source, and that
 * happens in the SERVER graph. Importing these from the client component put a
 * client reference there instead of the string, so the built page shipped
 * `getItem(undefined)` and the redirect could never fire. Unit tests cannot see
 * that: under bun both files are plain modules and the constant resolves.
 * Keeping the keys in a directive-free module gives both graphs the real value.
 */
export const LANGUAGE_CHOICE_KEY = 'bomdisoft.language';
export const LANGUAGE_OFFER_DISMISSED_KEY = 'bomdisoft.language-offer-dismissed';
